import { modalStateType } from "reducer/types";

export const SET_MODAL_STATE = (payload: modalStateType) => ({
    type: 'SET_MODAL_STATE',
    payload: payload
});

